/*
	Resize by mouse of any DOM element

	Usage:

  none/vertical/horizontal/both

  <div v-resize="horizontal">
  </div>
*/

exports.install = function ( Vue ) {
  const prevDef = e => {
    e.preventDefault();
    return false;
  };

	Vue.directive(
		"resize",
		{
			bind( element, binding, vnode ) {
        let rx = null, ry = null, sx = null, sy = null, w = null, h = null, c = null;
        switch ( ( "" + ( ( binding.value && binding.value.arg ) || binding.arg ) ).trim().toLowerCase() ) {
          case "none":
          return;
          
          case "horizontal":
            rx = true;
            ry = false;
            c = "ew-resize";
          break;
          
          case "vertical":
            rx = false;
            ry = true;
            c = "ns-resize";
          break;
          
          case "both":
            rx = true;
            ry = true;
            c = "nwse-resize";
          break;
          
          default:
            rx = true;
            ry = true;
            c = "nwse-resize";
        }
        
        const stop = () => {
          window.removeEventListener( "mouseup", stop );
          window.removeEventListener( "mousedown", stop );
          document.removeEventListener( "mouseout", stop );

          window.removeEventListener( "mousemove", resize );
          
          resizer.addEventListener( "mousedown", start );
        };

			  const start = e => {
			    e.stopPropagation();
			    
			    stop();

          resizer.removeEventListener( "mousedown", start );

          window.addEventListener( "mouseup", stop );
          window.addEventListener( "mousedown", stop );
          document.addEventListener( "mouseout", stop );
          
          window.addEventListener( "mousemove", resize );

          w = parseFloat( getComputedStyle( element, null ).getPropertyValue( "width" ).replace( "px", "" ) );
          h = parseFloat( getComputedStyle( element, null ).getPropertyValue( "height" ).replace( "px", "" ) );
          sx = null;
          sy = null;
          
          return false;
        };
        
        const resize = e => {
          const cx = e.clientX, cy = e.clientY;
          
          if ( sx === null ) sx = cx;
          if ( sy === null ) sy = cy;
          
          const dx = cx - sx;
          const dy = cy - sy;
          
          if ( rx ) element.style.width = ( w + dx ) + "px";
          if ( ry ) element.style.height = ( h + dy ) + "px";
        };
       
        const resizer = document.createElement( "div" );
        resizer.style.width = "10px";
        resizer.style.height = "10px";
        resizer.style.position = "absolute";
        resizer.style.right = "0";
        resizer.style.bottom = "0";
        resizer.style.overflow = "hidden";
        resizer.style.opacity = "0.5";
        resizer.style.cursor = c;
        resizer.className = "resizer";

        const stripes = document.createElement( "div" );
        stripes.style.transform = "translate( -50%, -50% ) rotate(-45deg) scale(0.5)";
        stripes.style.boxShadow = "#000000 0px 0px 0px 1px, #000000 0px 5px 0px 1px, #000000 0px 10px 0px 1px";
        stripes.style.position = "absolute";
        stripes.style.height = "0";
        stripes.style.top = "50%";
        stripes.style.left = "50%";
        stripes.style.width = "25px";
        resizer.appendChild( stripes );

        element.appendChild( resizer );
        resizer.addEventListener( "selectstart", prevDef );
        resizer.addEventListener( "dragstart", prevDef );
        element._resizeAPI = { stop, resizer };

        resizer.addEventListener( "mousedown", start );
			},

			update: function ( element, binding, vnode ) {
			},

			unbind: function ( element ) {
			  if ( element._resizeAPI ) {
			    const api = element._resizeAPI;
			    api.stop();

          api.resizer.removeEventListener( "selectstart", prevDef );
          api.resizer.removeEventListener( "dragstart", prevDef );
          api.resizer.removeEventListener( "mousedown", api.start );
          api.resizer.remove();

          delete element._resizeAPI;
        }
			}
		}
	);
};
